import React from "react";
import Header9 from "./../Common/Header9";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";

var bnrimg = require("../../images/banner/banner.jpg");

class ShopCheckout extends React.Component {
  render() {
    return (
      <>
        <Header9 />
        <div className="page-content">
          <Banner
            title="Mes informations"
            pagename="Mes informations"
            bgimage={bnrimg}
          />
          {/* SECTION CONTENT START */}
          <div className="section-full p-t80 p-b50 mobile-page-padding">
            {/* PRODUCT DETAILS */}
            <div className="container woo-entry">
              {/* SECTION CONTENT START */}
              <div className="section-content">
                <div className="row">
                  {/* FROM STYEL 1 WITH ICON */}
                  <div className="col-md-6 m-b30">
                    <div className="section-head">
                      <h4 className="text-uppercase">Pour information</h4>
                    </div>
                    <div className="your-order-list p-a30">
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s with the release of
                        Letraset
                      </p>
                      <p>
                        Pour toute demande d'information ou d'assistance
                        concernant vos données, Vous pouvez nous envoyer un
                        email sur <b>contact@associationlavallee.com</b>
                      </p>
                    </div>
                  </div>
                  {/* FROM STYEL 1 */}
                  <div className="col-md-6 m-b30">
                    <div className="section-head">
                      <h4 className="text-uppercase">Mes informations</h4>
                    </div>
                    <div className="bg-gray p-a30">
                      <form action="#" method="post">
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Nom Complet</label>
                              <input
                                type="text"
                                value="Youssef Ait Bamouh"
                                className="form-control"
                                placeholder="Nom Complet"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>CNIE</label>
                              <input
                                type="text"
                                value="GK77098"
                                className="form-control"
                                placeholder="CNIE"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Email Address</label>
                          <input
                            type="email"
                            value="youssef.aitbmamouh@um6p.ma"
                            className="form-control"
                            placeholder="Enter email"
                          />
                        </div>

                        <div className="form-group">
                          <label>Fonction</label>
                          <input
                            type="text"
                            value="Ingenieur"
                            className="form-control"
                            placeholder="Fonction"
                          />
                        </div>

                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Organisme</label>
                              <input
                                type="text"
                                value="LYTON"
                                className="form-control"
                                placeholder="Organisme"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Numéro Téléphone</label>
                              <input
                                type="text"
                                value="(+212) 0622435598"
                                className="form-control"
                                placeholder="Numéro Téléphone"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Situation Familiale</label>
                              <select
                                value="marié avec enfants"
                                className="form-control selectpicker"
                              >
                                <option disabled value="">
                                  Veuillez sélectionner une suggestion
                                </option>
                                <option value="célibataire">Célibataire</option>
                                <option value="marié sans enfant">
                                  Marié sans enfant
                                </option>
                                <option value="marié avec enfants">
                                  Marié avec enfant(s){" "}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Date de Naissance</label>
                              <input
                                type="date"
                                value="1990-05-17"
                                className="form-control"
                                placeholder="Date de Naissance"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Addresse</label>
                          <textarea
                            type="text"
                            rows={4}
                            value="201 Californie, Casablanca, Maroc, 20760"
                            className="form-control m-b30"
                            placeholder="Addresse"
                          />
                        </div>
                        <button
                          type="button"
                          value="submit"
                          className="site-cart-btn site-button-secondry"
                        >
                          Modifier
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* SECTION CONTENT END */}
            </div>
            {/* PRODUCT DETAILS */}
          </div>
          {/* CONTENT END */}
          {/* FOOTER START */}
          <Footer />
          {/* FOOTER END */}
        </div>
      </>
    );
  }
}

export default ShopCheckout;
